<template>
  <div>

    <el-form :inline="true" class="demo-form-inline">
      <el-form-item label="用户昵称:">
        <el-input v-model="nick" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="参与时间:">
        <div class="my_select_time">
        <el-date-picker prefix-icon="no_icon" v-model="postForm.startTime" type="date" :placeholder="'选择日期时间'"
            size="small" format="yyyy-MM-dd"
            value-format="yyyy-MM-dd" style="width: 120px; font-size: 12px" class="time1"
            :clearable="false"></el-date-picker>
          <div class="time_to_text">
            至
          </div>
          <el-date-picker prefix-icon="no_icon" v-model="postForm.endTime" type="date" :placeholder="'选择日期时间'"
            size="small" format="yyyy-MM-dd"
            value-format="yyyy-MM-dd" style="width: 145px; font-size: 12px" class="time2"
            :clearable="false"></el-date-picker>
          <i class="el-icon-circle-close date_icon1" @click="clearTimeSendTime()"></i>
          <img src="@/assets/images/select_date.svg" alt class="date_icon2" />
        </div>
      </el-form-item>
      <el-form-item label="进行动作:">
        <el-select style="width: 150px;" v-model="optType" placeholder="请选择">
          <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button class="b1" @click="querySeach()"><span style="marginleft: 4px">
            查询</span></el-button>
        <el-button class="b2" style="margin-left: 20px" @click="queryOne()"><span
            style="marginleft: 4px">重置</span></el-button>
      </el-form-item>
    </el-form>

    <el-table :data="tableData" :header-cell-style="{ background: '#F8F9FF', 'text-align': 'left' }"
      :cell-style="{ 'text-align': 'left' }" style="width: 100%; margin: 40px auto">
      <el-table-column prop="nick" label="用户昵称"></el-table-column>
      <el-table-column prop="joinTime" label="参与时间"></el-table-column>
      <el-table-column label="进行动作">
        <template slot-scope="scope">
          <span>{{ scope.row.optType | optTypeFilter }}</span>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination style="text-align: right; margin: 25px" @size-change="handleSizeChange" background
      @current-change="handleCurrentChange" :page-sizes="[10, 20, 30, 50, 100, 500]" :page-size="formList.size"
      layout="total, sizes, prev, pager, next, jumper" :total="totalNum"
      :current-page="formList.current"></el-pagination>
  </div>
</template>

<script>
import { getLiveRecord } from "@/api/liveCard/liveCard";
export default {
  components: {},
  data() {
    return {
      nick: "",
      optType: "",
      options: [
        {
          value: '',
          label: '全部'
        },
        {
          value: '1',
          label: '加入会员'
        },
        {
          value: '2',
          label: '领取入会后优惠券'
        }
      ],
      queryForm: {
        evaluateTime: "7",
      },
      postForm: {
        startTime: "",
        endTime: "",
      },
      // pickerOptionsEnd: {
      //   disabledDate: (time) => {
      //     if (this.postForm.startTime) {
      //       return time.getTime() < new Date(this.postForm.startTime).getTime();
      //     } else {
      //     }
      //   },
      // },
      // pickerOptionsStart: {
      //   disabledDate: (time) => {
      //     if (this.postForm.endTime) {
      //       return time.getTime() > new Date(this.postForm.endTime).getTime();
      //     } else {
      //     }
      //   },
      // },
      tableData: [],
      formList: {
        size: 10,
        current: 1
      },
      totalNum: 0
    };
  },

  filters: {
    optTypeFilter(v) {
      const arr = ["加入会员", "领取入会后优惠券"]
      return arr[Number(v) - 1]
    },
  },

  async mounted() {
    // await this.timeChange()
    await this.getLiveRecord()
  },

  methods: {
    //分页事件
    handleSizeChange(val) {
      this.formList.size = val;
      this.getLiveRecord();
    },

    handleCurrentChange(val) {
      this.formList.current = val;
      this.getLiveRecord();
    },

    // 查询
    querySeach() {
      this.getLiveRecord()
    },

    // 重置
    queryOne() {
      this.nick = ""
      this.optType = ""
      this.postForm.startTime = "";
      this.postForm.endTime = "";
      this.getLiveRecord()
    },

    // 列表数据
    async getLiveRecord() {
      if(this.postForm.startTime != "") {
        this.postForm.startTime = this.postForm.startTime.slice(0, 10)
        this.postForm.startTime = this.postForm.startTime + " " + "00:00:00"
      }
      if(this.postForm.endTime != "") {
        this.postForm.endTime = this.postForm.endTime.slice(0, 10)
        this.postForm.endTime = this.postForm.endTime + " " + "23:59:59"
      }
      
      const obj = {
        ...this.postForm,
        ...this.formList,
        nick: this.nick,
        optType: this.optType,
      }
      const res = await getLiveRecord(obj)
      this.tableData = res.data.records
      this.totalNum = res.data.total
    },

    //时间限制
    clearTimeSendTime() {
      this.postForm.startTime = "";
      this.postForm.endTime = "";
    },

    timeChange(type) {
      let self = this;
      let hh = new Date().getHours() < 10 ? "0" + new Date().getHours() : new Date().getHours();
      let mf = new Date().getMinutes() < 10 ? "0" + new Date().getMinutes() : new Date().getMinutes();
      let ss = new Date().getSeconds() < 10 ? "0" + new Date().getSeconds() : new Date().getSeconds();
      let tt = "00:00:00";
      const date = [self.getDay(-7, "-"), self.getDay(0, "-")];
      this.mytime = date;
      if (type == null) {
        this.postForm.startTime = `${this.mytime[0]} ${tt}`;
        this.postForm.endTime = `${this.mytime[1]} ${tt}`;
      } else if (type == 7) {
        this.postForm.startTime = `${this.mytime[0]} ${tt}`;
        this.postForm.endTime = `${this.mytime[1]} ${tt}`;
      } else if (type == 15) {
        this.mytime[0] = self.getDay(-15, "-");
        this.mytime[1] = self.getDay(0, "-");
        this.postForm.startTime = `${this.mytime[0]} ${tt}`;
        this.postForm.endTime = `${this.mytime[1]} ${tt}`;
      } else if (type == 30) {
        this.mytime[0] = self.getDay(-30, "-");
        this.mytime[1] = self.getDay(0, "-");
        this.postForm.startTime = `${this.mytime[0]} ${tt}`;
        this.postForm.endTime = `${this.mytime[1]} ${tt}`;
      } else {
        this.postForm.startTime = "";
        this.postForm.endTime = "";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.b1 {
  width: 98px;
  height: 32px;
  color: #fff;
  border: 1px solid #2670fb;
  background-color: #2670fb;

  &:hover {
    opacity: 0.8;
  }
}

.b2 {
  width: 98px;
  height: 32px;
  color: #666666;
  border: 1px solid #dddddd;
  background-color: #fff;

  &:hover {
    color: #2670fb;
    border: 1px solid #2670fb;
    background: rgba(38, 112, 251, 0.1);
  }
}
</style>
